import { FileTypes } from "@/enums";
import { selectFilterHelper } from "@/helpers";
import { Form, Input, Select } from "antd";
import { useIntl } from "react-intl";
import { FormFieldContainer } from "./styled";

export const AttachmentEditFormField = () => {
  const intl = useIntl();

  return (
    <FormFieldContainer>
      <Form.Item
        name={["property", "label", "fallback"]}
        label={intl.formatMessage({ id: "newFormField.fieldLabel" })}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.fieldLabelRequired",
            }),
          },
        ]}
      >
        <Input className="viper-form-element-max-width" />
      </Form.Item>
      <Form.Item
        name={["property", "placeholder", "fallback"]}
        label={intl.formatMessage({ id: "newFormField.placeholder" })}
      >
        <Input className="viper-form-element-max-width" />
      </Form.Item>
      <Form.Item
        name={["property", "requiredValidationText", "fallback"]}
        label={intl.formatMessage({ id: "newFormField.validationErrorText" })}
      >
        <Input className="viper-form-element-max-width" />
      </Form.Item>
      <Form.Item
        name={["property", "allowedFileTypes"]}
        label={intl.formatMessage({ id: "newFormField.allowedFileTypes" })}
      >
        <Select
          mode="multiple"
          style={{ maxWidth: 500 }}
          filterOption={selectFilterHelper}
        >
          {Object.keys(FileTypes).map((key) => (
            <Select.Option value={key} key={`allowed-file-types-option-${key}`}>
              {intl.formatMessage({
                id: `enum.fileType.${key}`,
                defaultMessage: key,
              })}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </FormFieldContainer>
  );
};
